import { plaintextValidator } from '../fields';

const config = { mandatory: true, customError: `can't be blank` };

export const provisionModalValidation =  {
  groupName: plaintextValidator(config)
};
